import { z } from "@/zod";

export const PROJECT_DEPENDENCY_DEPARTMENT = "department";
export const PROJECT_DEPENDENCY_ROLE = "role";
export const PROJECT_DEPENDS_ON = [
  PROJECT_DEPENDENCY_DEPARTMENT,
  PROJECT_DEPENDENCY_ROLE,
] as const;

export type ProjectDependsOn = (typeof PROJECT_DEPENDS_ON)[number];

export const projectDependsOn = z.enum(PROJECT_DEPENDS_ON);
